<template>
    <div>
        <el-card>
            <ul class="data-ul data-box">
                <li>
                    <span class="label-span" tkey="島嶼名稱">{{i18n.tkey("lang_island_name")}}:&nbsp;</span>
                    <span class="content-span">{{obj.recordname}}</span>
                </li>

                <li>
                    <span class="label-span" tkey="島嶼英文名稱">{{i18n.tkey("lang_island_name_en")}}:&nbsp;</span>
                    <span class="content-span">{{obj.addinfo6}}</span>
                </li>

                <li>
                    <span class="label-span" tkey="島嶼域名">{{i18n.tkey("lang_island_domain")}}:&nbsp;</span>
                    <span class="content-span">{{obj.addinfo18}}</span>
                </li>

                <li>
                    <span class="label-span" tkey="島嶼鏈接">{{i18n.tkey("lang_island_url")}}:&nbsp;</span>
                    <span class="content-span">
                        <CopyUrlButton :url="islandUrl" />
                        <QrcodePopoverButton :url="islandUrl" />
                    </span>
                    <div style="height: 10px">

                    </div>
                </li>

                <li>
                    <span class="label-span" tkey="邀請鏈接">{{i18n.tkey("lang_invite_url")}}:&nbsp;</span>
                    <span class="content-span">
                        <CopyUrlButton :url="invUrl" />
                        <QrcodePopoverButton :url="invUrl" />
                    </span>
                </li>

                <li class="operation-box">
                    <el-button
                        size="small"
                        type="info"
                        @click="goIslandView"
                        tkey="前往"
                    >
                        {{i18n.tkey("lang_goto")}}
                    </el-button>
                    &nbsp;
                    <el-button
                        size="small"
                        type="success"
                        @click="clickEdit"
                        tkey="編輯"
                    >
                        {{i18n.tkey("lang_modify")}}
                    </el-button>
                    &nbsp;
                    <el-button
                        size="small"
                        type="primary"
                        @click="clickManage"
                    >
                        {{i18n.tkey("lang_customer_manage")}}
                    </el-button>
                </li>
            </ul>
        </el-card>
    </div>
</template>

<script setup>

import {computed, inject, getCurrentInstance, toRef} from "vue";
import CopyUrlButton from "@/components/shopopee/button/copyUrlButton.vue";
import QrcodePopoverButton from "@/components/shopopee/button/qrcodePopoverButton.vue";
import {useUserinfo} from "@/stores/userinfo";

const props = defineProps(["obj"])
const emits = defineEmits(["clickEdit", "clickManage"])

const i18n = inject("i18n")
const { proxy } = getCurrentInstance()
const userInfoRef = toRef(useUserinfo())

const reload = inject("reload");

const invUrl = computed(() => {
    return `${proxy.$ThreeDShopopeePath}login?operation=signup&cicode=${props.obj.companycode}`
})

const islandUrl = computed(() => {
    return `${proxy.$ThreeDShopopeePath}${props.obj.id}/index`
})

function clickEdit(){
    emits("clickEdit", props.obj)
}

function clickManage(){
    emits("clickManage", props.obj)
}

function goIslandView(){
    userInfoRef.value.currPage = 1

    proxy.$router.push({path: `/${props.obj.id}/index`})

    if (proxy.$route.path.indexOf("/index") != -1){
        reload()
    }
}

</script>

<style scoped>
    .data-ul {
        list-style: none;
        padding-left: 0;
    }

    .label-span {
        color: #606266;
    }

    .content-span {
        color: #909399;
    }

    .data-box {
        line-height: 2;
        font-size: 14px;
        text-align: left;
    }

    .operation-box {
        margin-top: 20px;
        text-align: center;
    }
</style>